import { render, staticRenderFns } from "./NotificationsAside.vue?vue&type=template&id=211a3032&lang=pug&"
import script from "./NotificationsAside.vue?vue&type=script&lang=ts&"
export * from "./NotificationsAside.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports